import { useQuery } from '@tanstack/react-query';
import { useCommDispatcher } from '@/hooks/comm/use-comm';
import { allChatSessionQueryOptions } from '@/hooks/sessions/use-conversation-sessions';
import { useConversationSessionStore } from '@/stores/conversation-session';

export const useSubscribedSessionUnReadCountByUserId = () => {
  const { dispatch } = useCommDispatcher();
  const { subscribedSessions } = useConversationSessionStore();

  const query = useQuery({
    ...allChatSessionQueryOptions,
    enabled: !!subscribedSessions.length,
    select: (sessions) => {
      const subscriptions: Array<{ userId: number; count: number }> = [];

      if (subscribedSessions.length && sessions?.length) {
        for (const session of subscribedSessions) {
          const data = sessions?.find((s) => s.SessionType === 'session' && s.UserID === session.userId);
          if (!data) continue;

          let count = 0;
          if (data.IsNewSession) count = 1;
          if (data.UnReadCount === Number.POSITIVE_INFINITY) count = 1;
          else if (data.UnReadCount > 0) count = data.UnReadCount;

          dispatch({
            event: 'new-message',
            data: {
              session: {
                type: 'user',
                id: session.userId,
              },
              count,
            },
          });
          subscriptions.push({
            userId: session.userId,
            count,
          });
        }
      }

      return subscriptions;
    },
  });

  return {
    hasSubscribedSessions: subscribedSessions.length > 0,
    counts: query.data ?? [],
    ...query,
  };
};
